import React from "react";
import "./Expertise.css";
import skinImg from "../assets/skin.png";
import mental from "../assets/mentalHealth.png";
import child from "../assets/childHealth.png";
import lungs from "../assets/respiratory.png";
import joints from "../assets/bonesJoints.png";
import stomach from "../assets/digestive.png";
import womens from "../assets/womensHealth.png";
import chronic from "../assets/chronicPain.png";

const expertiseData = [
    {
        id: 1,
        title: "Skin & Hair Care",
        image: skinImg,
    },
    {
        id: 2,
        title: "Mental Wellness",
        image: mental,
    },
    {
        id: 3,
        title: "Child Health",
        image: child,
    },
    {
        id: 4,
        title: "Respiratory Care",
        image: lungs,
    },
    {
        id: 5,
        title: "Joint & Bone Care",
        image: joints,
    },
    {
        id: 6,
        title: "Digestive Health",
        image: stomach,
    },
    {
        id: 7,
        title: "Women's Health",
        image: womens,
    },
    {
        id: 8,
        title: "Chronic Disease",
        image: chronic,
    },
];

const Expertise = () => {
    return (
        <section className="expertise-section">
            <h2 className="expertise-title">AREA OF EXPERTISE</h2>
            <div className="expertise-grid">
                {expertiseData.map((item) => (
                    <div key={item.id} className="expertise-card">
                        <div className="expertise-image">
                            <img src={item.image} alt={item.title} />
                        </div>
                        <h3 className="expertise-card-title">{item.title}</h3>
                        <p className="expertise-card-description">{item.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};
export default Expertise;